export const initialUserName = {
  clientName: "",
  clientCode: "",
  alphabetic: "",
  numeric: "",
  format: "",
};
